import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { MatTableDataSource, PageEvent, Sort, MatExpansionPanel, MatSort, MatSnackBar } from '@angular/material';
import { Subscription } from 'rxjs';
import { Producto, ProductoEstado } from '../../../interfaces/producto';
import { ProductoService } from '../../../providers/producto.service';
import { PermisoService } from '../../../providers/permiso.service';
import { TipoProducto } from '../../../interfaces/tipo-producto';
import { Caracteristica } from '../../../interfaces/caracteristica';
import { VolverService } from '../../../providers/volver.service';
import * as moment from 'moment';
import { ZerosPipe } from '../../../pipes/transforms/zeros.pipe';
import { FormatDatePipe } from '../../../pipes/transforms/format-date.pipe';
import { BooleanTraductorPipe } from '../../../pipes/transforms/boolean-traductor.pipe';
import { CaracteristicaService } from '../../../providers/caracteristica.service';

@Component({
  selector: 'app-ver-productos',
  templateUrl: './ver-productos.component.html',
  styleUrls: ['./ver-productos.component.scss']
})
export class VerProductosComponent implements OnInit {
  title = "Productos";
  actualizarTablaTimeout: any; // prevenir muchos llamados consecutivos al webserver
  flag_primera_carga: boolean = true; // primera solicitud a traer datos
  cargandoTimeout: any;
  cargando: boolean = true; // para mostrar el progress-bar luego de un tiempo de busqueda
  tablaProductosColumnas = ["fechaAlta", "tipoProducto", "descripcion", "importe"];
  productosDataSource = new MatTableDataSource();
  @ViewChild(MatSort) matSort: MatSort;
  sort: Sort = { active: '', direction: '' };
  page: PageEvent = new PageEvent();
  getProductosSuscripcion = new Subscription();
  productosCount: number = 0;
  @Input() filtrosExternos: any = {}; // filtros que se aplican según el lugar donde se muestran las productos
  private tipoOferta: string; // filtro para la categoria del tipo de producto
  private oferta: string; // filtro para la categoria del tipo de producto
  tieneFiltrosOrdenPaginado = false;
  // true si hay almenos un filtro activo
  panelConFiltroActivo = false;
  filtros: any = {
    generico: ''
  };
  @ViewChild('filtrosPanel') set filtrosPanel(v: MatExpansionPanel) {
    if (typeof v != 'undefined') {
      setTimeout(() => {
        this.checkPageState();
        if (this.panelConFiltroActivo) {
          v.open();
        }
      }, 0);
    }
  };
  descargandolistado: boolean = false;
  cargandoCaracteristicas: boolean = false;
  caracteristicas = [];

  constructor(
    private productoService: ProductoService,
    private permisoService: PermisoService,
    private volverSv: VolverService,
    private snackBar: MatSnackBar,
    private zerosPipe: ZerosPipe,
    private datePipe: FormatDatePipe,
    private booleanPipe: BooleanTraductorPipe,
    private caracteristicaSv: CaracteristicaService,
    private ProductoService: ProductoService,
  ) {
    this.permisoService.tienePermiso('WEB').then(tienePermiso => {
      if (tienePermiso) {
        this.tablaProductosColumnas.push('web');
      }
    });

    this.permisoService.tienePermiso('PRODUCTO-ACCIONES').then(tienePermiso => {
      if (tienePermiso) {
        this.tablaProductosColumnas.push('acciones');
      }
    });
  }

  ngOnInit() {
    this.tipoOferta = this.ProductoService.getTipoOferta();
    this.oferta = this.tipoOferta == '2' ? 'servicio' : 'producto';
    this.title = this.tipoOferta == '2' ? 'Servicios' : 'Productos';
    
    this.traerCaracteristicas();

    // set valores iniciales
    if (this.volverSv.usaronBotonVolver()) {
      this.restaurarPageState();
    } else {
      this.reiniciarPageState();
    }
  }

  /**
   * Para arreglar un bug de angular usamos esta funcion para ordenar
   */
  setActiveSortProgrammatically(active, direction): void {
    let interval = setInterval(() => {
      if (this.matSort) {
        clearInterval(interval);
        if (this.sort.active != active || this.sort.direction != direction) {
          this.sort = <MatSort>{
            active: active,
            direction: direction
          };
          this.matSort.sort({
            id: active,
            start: direction,
            disableClear: true
          });
          // ugly hack!
          const activeSortHeader = this.matSort.sortables.get(active);
          if (activeSortHeader) {
            activeSortHeader['_setAnimationTransitionState']({
              fromState: direction,
              toState: 'active'
            });
          }
        }
      }
    }, 0);
  }

  sortData(sort: Sort) {
    this.sort = sort;
    this.actualizarTabla();
  }

  onPage(pageEvent: PageEvent) {
    localStorage.setItem('ver_productos_paginado_size', pageEvent.pageSize.toString());
    this.page = pageEvent;
    this.actualizarTabla();
  }

  onFiltro() {
    this.page.pageIndex = 0;
  }

  /**
   * limpia las variables de page state
   * y luego restaura el estado al estado inicial
   */
  reiniciarPageState() {
    this.limpiarPageState();
    this.restaurarPageState();
  }

  /**
   * olvidar el estado de la página
   */
  limpiarPageState() {
    // filtros
    localStorage.setItem('ver_productos_filtros', null);
    // paginado
    localStorage.setItem('ver_productos_paginado', null);
    // sort
    localStorage.setItem('ver_productos_sort', null);
  }

  /**
   * recuerda el estado de la página por si vuelven a ingresar
   * y hay que mostrarla tal cual como estaba
   */
  recordarPageState() {
    // filtros
    localStorage.setItem('ver_productos_filtros', JSON.stringify(this.filtros));
    // paginado
    localStorage.setItem('ver_productos_paginado', JSON.stringify(this.page));
    // sort
    localStorage.setItem('ver_productos_sort', JSON.stringify(this.sort));
  }

  /**
   * restaudar la página al estado en que estaba
   */
  restaurarPageState() {
    // filtros
    let localFiltros = JSON.parse(localStorage.getItem('ver_productos_filtros'));
    if (localFiltros != null) {
      this.filtros = localFiltros;
    } else {
      for (let propiedad in this.filtros) {
        this.filtros[propiedad] = '';
      }
    }
    // paginado
    let localPaginado = JSON.parse(localStorage.getItem('ver_productos_paginado'));
    if (localPaginado != null) {
      this.page = localPaginado;
    } else {
      this.page.pageIndex = 0;
      this.page.pageSize = +localStorage.getItem('ver_productos_paginado_size') || 10;
      this.page.length = 0;
    }
    // sort
    let localSort = JSON.parse(localStorage.getItem('ver_productos_sort'));
    if (localSort != null) {
      // para el sort tenemos que hacerlo con un "set" porque arregla un bug de "matSort"
      this.setActiveSortProgrammatically(localSort.active, localSort.direction);
    } else {
      this.setActiveSortProgrammatically('fechaAlta', 'desc');
    }
    this.actualizarTabla();
  }

  /**
   * revisa las variables de page state para ver
   * si hay almenos una aplicada ya sea filtrado, paginado u ordenamiento
   */
  checkPageState(): boolean {
    this.tieneFiltrosOrdenPaginado = false;
    // checkear si hay almenos un filtro aplicado
    this.panelConFiltroActivo = false;
    for (let propiedad in this.filtros) {
      if (this.filtros[propiedad]) {
        this.tieneFiltrosOrdenPaginado = true;
        this.panelConFiltroActivo = true;
        break;
      }
    }
    // checkear si hay paginado
    if (this.page.pageIndex != 0) {
      this.tieneFiltrosOrdenPaginado = true;
    }
    // checkear si hay ordenamiento
    if (this.sort.active != '' && (this.sort.active != 'fechaAlta' || this.sort.direction != 'desc')) {
      this.tieneFiltrosOrdenPaginado = true;
    }

    return this.tieneFiltrosOrdenPaginado;
  }

  actualizarTabla(): void {
    clearTimeout(this.actualizarTablaTimeout);
    this.actualizarTablaTimeout = setTimeout(() => {
      clearTimeout(this.cargandoTimeout);
      this.cargandoTimeout = setTimeout(() => { // mostrar cargando si tarda mas de algun tiempo de busqueda
        this.cargando = true;
      }, 750);

      if (this.getProductosSuscripcion && !this.getProductosSuscripcion.closed) {
        this.getProductosSuscripcion.unsubscribe();
      }

      this.recordarPageState();
      this.checkPageState();
      this.getProductosSuscripcion = this.productoService
        .getProductos(
          {
            page: this.page.pageIndex,
            pageSize: this.page.pageSize
          },
          {
            sort: this.sort.active,
            order: this.sort.direction
          },
          Object.assign(this.filtrosExternos, Object.assign({ especial: false, tipoOferta: this.tipoOferta }, this.filtros))
        )
        .subscribe( // suscribimos una nueva busqueda
          respuesta => {
            if (respuesta.estado == 1 && respuesta.data) {
              if (respuesta.data.total) {
                this.productosCount = respuesta.data.total;
              }

              var productos: Producto[] = []; // array de datos obtenidos   
              if (respuesta.data.productos) {
                respuesta.data.productos.forEach(producto => {
                  productos.push(new Producto(
                    producto.IdProducto,
                    producto.fechaAlta,
                    producto.descripcion,
                    producto.stock,
                    producto.observaciones,
                    !!+producto.web,
                    !!+producto.destacado,
                    producto.importe,
                    !!+producto.importeMostrar,
                    <ProductoEstado>{
                      IdEstado: producto.estado.id,
                      descripcion: producto.estado.desc
                    },
                    <TipoProducto>{
                      id: producto.tipo.id,
                      descripcion: producto.tipo.desc
                    },
                    <Caracteristica[]>[], // blanquear caracteristicas
                    !!+producto.descripcionCustom,
                    !!+producto.especial
                  ));
                });
              }

              this.productosDataSource.data = productos;
            }
          },
          () => {
            clearTimeout(this.cargandoTimeout); // ya no es necesario mostrar la progress bar
            this.cargando = false; // ocultar progress bar si se estaba mostrando
          },
          () => {
            clearTimeout(this.cargandoTimeout); // ya no es necesario mostrar la progress bar
            this.cargando = false; // ocultar progress bar si se estaba mostrando
          }
        );
    }, (this.flag_primera_carga ? 0 : 220));

    this.flag_primera_carga = false;
  }

  traerCaracteristicas() {
    this.cargandoCaracteristicas = true;
    this.caracteristicaSv.getCaracteristicas().subscribe(
      respuesta => {
        this.caracteristicas = [];
        if (respuesta && respuesta.estado == 1 && respuesta.data) {
          this.caracteristicas = respuesta.data;
        }
      },
      () => {
        this.cargandoCaracteristicas = false;
      },
      () => {
        this.cargandoCaracteristicas = false;
      }
    );
  }

  descargarListado() {
    this.descargandolistado = true;
    this.productoService.getProductos(
      {
        page: 0,
        pageSize: this.productosCount
      },
      {
        sort: this.sort.active,
        order: this.sort.direction
      },
      Object.assign(this.filtrosExternos, this.filtros)
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.productos) {
          let titulosArr = [
            "Fecha de alta",
            "Tipo de producto",
            "Descripción",
            "Importe",
            "Observaciones"
          ];
          if (this.caracteristicas.length > 0) {
            this.caracteristicas.forEach((caracteristica) => {
              titulosArr.push(caracteristica.descripcion);
            });
          }
          const titulos = titulosArr.join(';') + "\r\n";
          const datos = respuesta.data.productos.map((a: any) => {
            let row = [
              this.datePipe.transform(a.fechaAlta, "YYYY-MM-DD HH:mm:ss", "DD/MM/YYYY HH:mm:ss"),
              a.tipo.desc,
              a.descripcion,
              a.importe,
              a.observaciones
            ];
            this.caracteristicas.forEach((caracteristica) => {
              let seted = false;
              a.caracteristicas.forEach((prodCarac) => {
                if (caracteristica.IdCaracteristica == prodCarac.IdCarac) {
                  seted = true;
                  row.push(prodCarac.valor);
                  return;
                }
              });
              if (!seted)
                row.push("");
            });
            return row.join(';');
          }).join("\r\n");

          const csvConfig = "data:text/csv;charset=utf-8,%EF%BB%BF";
          let csvContent = titulos + datos;
          let downloadLink = document.createElement("a");
          downloadLink.href = csvConfig + encodeURI(csvContent);
          downloadLink.download = this.title + "_" + moment().format("YYYYMMDD_HHmmss") + ".csv";
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        } else {
          this.fallaDescargarListado();
        }
      },
      () => {
        this.descargandolistado = false;
        this.fallaDescargarListado();
      },
      () => {
        this.descargandolistado = false;
      }
    );
  }

  fallaDescargarListado() {
    this.snackBar.open('Lo sentimos, no se pudo descargar el listado', 'OK', { duration: 4750 });
  }

  ngOnDestroy() {
    if (this.getProductosSuscripcion && !this.getProductosSuscripcion.closed) {
      this.getProductosSuscripcion.unsubscribe();
    }
  }
}
